<template>
	<div id="pageRoot">

		<div class="enciclopedia">
			<p class="textBaseCourier" id="text01">
				Los lobos, gracias a su excelente oído y su desarrollado olfato, ayudaban a los humanos a seguir el rastro de los animales salvajes. Los seres humanos con sus lanzas o flechas los cazaban. Al final de la cacería, compartían el alimento.
			</p>

			<img id="imgCavePainting" src="/pages/img/imgCavePainting.jpg">

			<p class="textBaseCourier" id="text02">
				EL ORIGEN DE LOS PERROS
			</p>
			<p class="textBaseCourier" id="text03">
				Los lobos, al volverse animales domésticos, se fueron transformando, dando origen a los perros.
			</p>
			<p class="textBaseCourier" id="text04">
				*Texto adaptado para este cuaderno.
			</p>

		</div>

		<img src="/pages/img/sordo/svgPage85AweZorrito.svg" id="aweZorrito" class="hover-animation-a">

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
#text01
{
position: absolute;
width: 417px;
height: 297px;
left: 34px;
top: 80px;

font-weight: normal;
font-size: 22px;
line-height: 33px;

color: #000000;
}
#text02
{
position: absolute;
width: 492px;
height: 51px;
left: 29px;
top: 429px;

font-weight: bold;
font-size: 35px;
line-height: 40px;

color: #231F20;
}
#text03
{
position: absolute;
width: 750px;
height: 72px;
left: 33px;
top: 483px;

font-weight: normal;
font-size: 22px;
line-height: 33px;

color: #000000;
}
#text04
{
position: absolute;
width: 750px;
height: 30px;
left: 31px;
top: 575px;

font-weight: normal;
font-size: 22px;
line-height: 33px;

color: #000000;
}
#text05
{
position: absolute;
width: 490px;
height: 35px;
left: 39px;
top: 639px;

font-weight: normal;
font-size: 24px;
line-height: 33px;

color: #EF1111;
text-decoration: none;
}
#imgCavePainting
{	
position: absolute;
width: 387px;
height: 278px;
left: 496px;
top: 100px;
}
#aweZorrito
{
z-index: 4;
position: absolute;
width: 394px;
height: 308.16px;
left: 649px;
top: 530px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p86-88/V104.mp4", "p86-88/V105.mp4", "p86-88/V106.mp4", "p86-88/V107.mp4", "p86/V108.mp4", "p86/V109.mp4", "p86/V110.mp4"]
    }
  }
}
</script>